import { createStyles } from '@codeleap/styles'
import { StyleRegistry } from '../styles'
import { textVariant } from './Text'
import { ButtonComposition } from '@codeleap/web'
import { LogoComposition } from './Logo'

export type NavigationMenuParts =
  | 'wrapper'
  | 'content'
  | 'content:drawer'
  | 'linksWrapper'
  | 'linkWrapper'
  | 'linkWrapper:first'
  | 'linkWrapper:last'
  | `linkButton${Capitalize<ButtonComposition>}`
  | `logo${Capitalize<LogoComposition>}`

export type NavigationMenuComposition = NavigationMenuParts

const createNavigationMenuVariant = createStyles<NavigationMenuComposition>

export const NavigationMenuStyles = {
  default: createNavigationMenuVariant((theme) => ({
    wrapper: {
      ...theme.presets.column,
    },
    logoWrapper: {
      ...theme.spacing.marginBottom(2),
      width: theme.values.iconSize[4],
      height: theme.values.iconSize[4],
    },
    linksWrapper: {
      ...theme.presets.flex,
      ...theme.presets.column,
      ...theme.spacing.gap(1),
    },
    linkWrapper: {
      ...theme.presets.fullWidth,
    },
    linkButtonWrapper: {
      height: theme.size['xx-large'],
      backgroundColor: 'transparent',
      borderRadius: theme.radius.infinite,
      ...theme.border({
        color: 'transparent',
        width: 0,
      }),
      ...theme.presets.fullWidth,
      ...theme.presets.row,
      ...theme.spacing.gap(0),
      ...theme.presets.justifyStart,

    },
    'linkButtonWrapper:selected': {
      backgroundColor: theme.baseColors.primarySolid50,
    },
    linkButtonIcon: {
      width: theme.values.iconSize[3],
      height: theme.values.iconSize[3],
      color: theme.baseColors.neutralSolid500,
      flexShrink: 0,

      ...theme.spacing.marginRight(1),

    },
    'linkButtonIcon:selected': {
      color: theme.colors.buttonHighlightSecondaryIconDefault,
    },
    linkButtonText: {
      ...theme.spacing.marginRight('auto'),
      ...textVariant(['p3', 'medium']),
      color: theme.baseColors.neutralSolid500,
      ...theme.spacing.marginRight(1),

    },
    'linkButtonText:selected': {
      color: theme.colors.buttonHighlightSecondaryIconDefault,
    },
    linkButtonBadge: {
      position: 'absolute',
      top: 12,
      left: 45,
    },
  })),
  compact: createNavigationMenuVariant((theme) => ({
    wrapper: {
      ...theme.presets.fullHeight,
      ...theme.presets.column,
      ...theme.presets.alignCenter,
      ...theme.presets.justifyStart,
      ...theme.spacing.px(2),
      ...theme.spacing.py(3),
      ...theme.spacing.gap(1),
      width: 128,
      minWidth: 128,
      maxWidth: 128,

      [theme.media.down('tablet')]: {
        width: 60,
        minWidth: 60,
        maxWidth: 60,
        ...theme.spacing.gap(2),
      },
    },
    content: {
      backgroundColor: theme.colors.bgDefault,
      borderRadius: theme.radius.medium,
    },
    linkButtonWrapper: {
      minWidth: 96,
      minHeight: 64,
      ...theme.presets.column,
      ...theme.spacing.gap(0.5),
      ...theme.spacing.py(1.5),

      [theme.media.down('tablet')]: {
        width: 48,
        minWidth: 48,
        minHeight: 48,
        ...theme.presets.column,
        ...theme.spacing.gap(0.5),
        ...theme.spacing.py(1.5),
      },
    },
    linkButtonIcon: {
      ...theme.spacing.margin(0),
    },
    linkButtonText: {
      ...theme.spacing.marginRight(0),
      ...textVariant(['c3']),

      [theme.media.down('tablet')]: {
        display: 'none',
      },
    },
    logoWrapper: {
      ...theme.spacing.marginBottom(2),
    },
    'linkWrapper:last': {
      ...theme.spacing.marginTop('auto'),
      ...theme.spacing.paddingTop(1),
      ...theme.border({ width: 1, color: theme.baseColors.neutralSolid300, directions: ['top'] }),
    },
    linkButtonBadge: {
      [theme.media.down('tablet')]: {
        top: 4,
        left: 20,
      },
    },
  })),
}

StyleRegistry.registerVariants('NavigationMenu', NavigationMenuStyles)
